var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-div"},[_c('div',[_c('img',{staticClass:"read",class:{ expanded: _vm.isReadMore },attrs:{"role":"button","src":require('../../images/Plus.svg'),"alt":"open-close"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }